import { useEffect } from "react"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const usePutStoreManagerApprove = () => {

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    const request = (e, idx) => {
        e.stopPropagation()
        fetchRequest("PUT", `/admin/store/manager/${idx}/approve`)
    }

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 200:
                window.location.reload()
                break
            case 400:
                if (fetchResult?.data?.error_code === "manager_idx") setAlert("매니저 idx를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) setAlert("매니저 데이터가 존재하지 않습니다.")
                break
            case 409:
                if (fetchResult?.data?.error_code === 1) setAlert("이미 승인된 매니저 입니다.")
                break
        }
    }, [fetchResult])

    return [request]
}

export default usePutStoreManagerApprove